import { useQuery } from "@tanstack/react-query";
import api from "../../../services/api";

const FEATURE_FLAG_URL = "/fulfilment/accounts-payable/api/v1/vip/feature-flags";

async function fetchInvoiceV2Flag(): Promise<boolean> {
  const res = await api.post(FEATURE_FLAG_URL, { features: ["vip_v2"] });
  // Response shape: { "vip_v2": "allow" | "deny" }
  return res?.vip_v2 === "allow";
}

export function useInvoiceV2Flag() {
  const { data: isV2 = false, isLoading } = useQuery(
    ["invoiceFeatureFlag", "vip_v2"],
    fetchInvoiceV2Flag,
    {
      staleTime: 5 * 60 * 1000, // 5 min cache
      retry: false,             // on error → isV2 = false → v1 shown (safe fallback)
    },
  );
  return { isV2, isLoading };
}
